import React, { useEffect, useState } from "react";
import QuestionnaireTitle from "../../../Components/ModuleComponents/SurveyQuestionnaire/QuestionnaireTitle.js";
import SectionForm from "../../../Components/Modal/SectionForm.js";
import SectionListMenu from "../../../Components/ModuleComponents/SurveyQuestionnaire/SectionListMenu.js";
import QuestionForm from "../../../Components/Modal/QuestionForm/index.js";
import useApi from "../../../Hooks/useApi.js";
import Button from "../../../Components/UI/Buttons/Button.js";
import QuestionListings from "../../../Components/ModuleComponents/SurveyQuestionnaire/QuestionListings.js";
import { useLocation, useNavigate } from "react-router-dom";
import showToast from "../../../Helpers/toast.js";
import Modal from "../../../Components/Modal/index.js";
import { useModal } from "../../../Hooks/useModal.js";
import Common from "../../../Components/Layouts/Common.js";
import { getQuestionTypes, getSectionList, getSectionQuestion,
  getQuestionnaireData, markComplete, sortBySectionOrder } from "../../../Utils/questionnaireUtils.js";
import { handleApiError } from "../../../Helpers/ErrorHandler.js";

const CreateSurveyQuestionnaire = () => {
  const location = useLocation();
  const { id, name, isTemplate } = location?.state || {};
  const [questionnaireMeta, setQuestionnaireMeta] = useState(
    id ? { id, name, isTemplate } : null
  );
  const [currentQuestionOrder, setCurrentQuestionOrder] = useState(0);
  const [sectionList, setSectionList] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [questionList, setQuestionList] = useState(null);
  const [selectedQuestionData, setSelectedQuestionData] = useState(null);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [isQuestionExist, setIsQuestionExist] = useState(false);

  const { request } = useApi();
  const { isOpen, openModal, closeModal } = useModal();
  const navigate = useNavigate();

  useEffect(
    (prev) => {
      if (prev?.id !== questionnaireMeta?.id) {
        navigate(".", {
          replace: true,
          state: { id: questionnaireMeta.id, name: questionnaireMeta.name },
        });
      }
    },
    [questionnaireMeta]
  );

  useEffect(() => {
    if (questionList && questionList.length > 0) {
      let max_order = 0;
      questionList?.forEach((question_item) => {
        if (question_item.order > max_order) {
          max_order = question_item.order;
        }
      });

      setCurrentQuestionOrder(max_order);
    }
  }, [questionList]);

  const fetchSectionList = async () => {
    try {

      const response = await getSectionList(request, questionnaireMeta?.id, "survey");
      const pre_response = await getQuestionnaireData(request, questionnaireMeta?.id,"survey");

      setSectionList(
        sortBySectionOrder(
          pre_response.questions && pre_response.questions.length > 0
            ? [
                {
                  name: "Without Section",
                  sectionOrder: -1,
                  sectionId: -1,
                  questions: response.questions,
                },
                ...response,
              ]
            : [...response]
        )
      );

      response && response?.length && setSelectedSection(response[0].sectionId);
    } catch (error) {
      handleApiError(error);
    }
  };
  const fetchSectionQuestion = async () => {
    if (selectedSection && selectedSection > 0) {
      try {
        const response =  await getSectionQuestion(request, selectedSection,"survey");
        
        
        // await request(
        //   "GET",
        //   `/v1/survey/sections/questions/${selectedSection}`,
        //   {},
        //   "survey_service"
        // );
        setQuestionList(response?.questions);
      } catch (error) {
        handleApiError(error);
      }
    } else {
      try {
        const response = await  getQuestionnaireData(request, questionnaireMeta?.id,"survey");
        setQuestionList(response?.questions);
      } catch (error) {
        console.log(error);
        
      }
      
    }
  };

  const fetchQuestionTypes = async () => {
    try {
      const response =   await getQuestionTypes(request,"survey");
      
      
      // await request(
      //   "GET",
      //   `/v1/survey/questions/type`,
      //   {},
      //   "survey_service"
      // );

      setQuestionTypes(
        response?.map((item) => ({
          name: item?.replace("_", " "),
          value: item,
        }))
      );
    } catch (error) {
      handleApiError(error);
      console.log(error);
    }
  };


 const checkQuestionsExist = async () => {
 
    try {
      const pre_response =  questionnaireMeta?.id && await getQuestionnaireData(request, questionnaireMeta?.id,"survey");
      return (
        pre_response?.sections?.some(
          (sec) => sec?.questions && sec?.questions?.length > 0
        ) || pre_response?.questions?.length > 0
      );
    } catch (error) {
      console.error("Error fetching questionnaire data:", error);
      // throw error;
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const exists = await checkQuestionsExist();
        setIsQuestionExist(exists);
      } catch (error) {
        handleApiError(error);
      }
    })();
  }, [sectionList,questionList]);


  const handleSendComplete = async () => {
    const { id } = questionnaireMeta;
    try {
      if (
        !isQuestionExist
      ) {
        showToast({
          message: `Finalizing Failed. \n  No Question Found!`,
          type: "error",
        });
        return;
      }

      const response = await markComplete(
        request,
        {
          questionnaireId: id,
          status: "COMPLETED",
        },
        "survey"
      );

      showToast({ message: response.message });
      navigate("/survey-questionnaire");
    } catch (error) {
      console.log(error);
      handleApiError(error);
      // showToast({ message: error?.response?.data?.message, type: "error" });
    }
  };



  useEffect(() => {
    if (questionnaireMeta) {
      fetchSectionList();
      fetchQuestionTypes();
    }
  }, [questionnaireMeta]);

  useEffect(() => {
    if (!selectedSection) {
      setQuestionList([]);
    } else {
      fetchSectionQuestion();
    }
  }, [selectedSection]);

  const handleSectionModalOpen = () => {
    openModal("section-modal");
  };
  const handleQuestionModalOpen = (mode, questionData) => {
    if (mode !== "edit") {
      setSelectedQuestionData(null);
    } else {
      setSelectedQuestionData(questionData);
    }
    openModal("question-modal");
  };

  return (
    <Common headline={"Create Survey Questionnaire"}>
      {/* View and Add QUESTIONNAIRE TITLE */}
      <QuestionnaireTitle
        questionnaireMeta={questionnaireMeta}
        setQuestionnaireMeta={setQuestionnaireMeta}
        moduleType="survey"
      />
      {questionnaireMeta ? (
        <div className="border rounded-lg p-1 mt-2 w-full">

          {/* Section List Strip */}
          {questionnaireMeta ? (
            <div className="flex flex-wrap sm:flex-nowrap justify-between items-center gap-3 h-full border rounded-lg p-1">
              <div className="w-auto min-w-[100px] overflow-auto">
                {questionnaireMeta && sectionList && sectionList.length ? (
                  <SectionListMenu
                    questionnaireMeta={questionnaireMeta}
                    sectionList={sectionList}
                    setSectionList={setSectionList}
                    selectedSection={selectedSection}
                    setSelectedSection={setSelectedSection}
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="text-end self-end justify-end w-auto sm:w-1/4">
                {questionnaireMeta && (
                  <Button
                    type="small"
                    handler={handleSectionModalOpen}
                    style={{ borderRadius: "5px", backgroundColor: "#2F4B7C" }}
                    label={<p className="font-bold">Add New Section</p>}
                  />
                )}
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* Modal Trigger selction Buttons mt-2 pb-2 px-2 pl-10*/}
          {questionnaireMeta && selectedSection ? (
            <div className="border px-1 mt-2 pb-3 rounded-lg">
              <div className="py-1 gap-4 flex items-center justify-start">
                <Button
                   type="small"
                  handler={handleQuestionModalOpen}
                  style={{ borderRadius: "5px", backgroundColor: "#2F4B7C" }}
                  label={<p className="font-bold">Add New Question</p>}
                />
              </div>

              {/* Question added to current Section */}
              <QuestionListings
                openQuestionModal={(questionData) =>
                  handleQuestionModalOpen("edit", questionData)
                }
                list={questionList}
                setter={setQuestionList}
              />
            </div>
          ) : (
            <></>
          )}

          

          {/* Modal Container for all modals */}

          {isOpen === "section-modal" ? (
            <Modal
              isOpen={isOpen}
              onClose={closeModal}
              style={{ width: "70vw" }}
            >
              <SectionForm
                questionnaireId={questionnaireMeta.id}
                sectionList={sectionList}
                setSectionList={setSectionList}
                sideFunctions={(section_id) => {
                  closeModal();
                  setSelectedSection(section_id);
                }}
                moduleType="survey"
              />
            </Modal>
          ) : isOpen === "question-modal" ? (
            <Modal
              isOpen={isOpen}
              onClose={closeModal}
              style={{ maxWidth: "80vw", overflow: "auto" }}
              outsideDisabled={true}
            >
              <QuestionForm
                questionTypes={questionTypes}
                questionList={questionList}
                setQuestionList={setQuestionList}
                selectedQuestionData={selectedQuestionData}
                currentSection={
                  sectionList &&
                  selectedSection &&
                  sectionList?.find(
                    (section) => section.sectionId === selectedSection
                  )
                }
                sideFunctions={(section_id) => {
                  closeModal();
                }}
                orders={{
                  value: currentQuestionOrder,
                  setter: setCurrentQuestionOrder,
                }}
                moduleType={"survey"}
              />
            </Modal>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}


      {/* COMPLETE BUTTON */}
      {!isTemplate && questionnaireMeta?.id &&
          sectionList &&
          sectionList.length  && isQuestionExist ? (
            <div className="py-2 text-center">
              <Button
                type="small"
                label={"Mark Complete"}
                backgroundColor={"#007CDD"}
                handler={handleSendComplete}
              />
            </div>
          ) : (
            <></>
          )}
    </Common>
  );
};

export default CreateSurveyQuestionnaire;
